import ServiceCard from '@/components/ServiceCard'

const serviceCategories = [
  { name: 'Consultas', icon: 'ph ph-stethoscope', href: '/consultas' },
  { name: 'Medicina preventiva', icon: 'ph ph-syringe', href: '/medicina-preventiva' },
  { name: 'Atención por Especie', icon: 'ph ph-paw-print', href: '/atencion-por-especie' },
  { name: 'Cirugía', icon: 'ph ph-bandage', href: '/cirugia' },
  { name: 'Internación y Cuidados', icon: 'ph ph-house-line', href: '/internacion-y-cuidados' },
  { name: 'Enfermería', icon: 'ph ph-first-aid', href: '/enfermeria' },
  { name: 'Laboratorio básico', icon: 'ph ph-microscope', href: '/laboratorio-basico' },
  { name: 'Dermatología', icon: 'ph ph-pill', href: '/dermatologia' },
  { name: 'Odontología', icon: 'ph ph-tooth', href: '/odontologia' },
  { name: 'Producción animal', icon: 'ph ph-cow', href: '/produccion-animal' },
  { name: 'Bromatología', icon: 'ph ph-shield-check', href: '/bromatologia' },
  { name: 'Bienestar y Asesoramiento', icon: 'ph ph-heartbeat', href: '/bienestar-y-asesoramiento' },
]

function Home() {
  return (
    <div className="relative min-h-screen bg-background" data-build-fix="true">
      <div className="watermark" aria-hidden="true"></div>
      <section className="page-hero h-[60vh] md:h-[70vh] flex items-center justify-center">
        <img
          src="/Docs/Fotos/Horcon foto.png"
          alt="Veterinario profesional en clínica"
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary/70"></div>
        <div className="relative text-center text-white px-4 max-w-3xl">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 drop-shadow-lg">Cuidado veterinario integral para tu familia animal</h1>
          <p className="text-lg md:text-xl mb-8 drop-shadow-md">Profesionalismo, prevención y dedicación en cada consulta.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
          </div>
        </div>
      </section>

      <section id="services-section" className="py-12 md:py-16 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-text-primary mb-12">Servicios Destacados</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {serviceCategories.map((service, index) => (
              <ServiceCard
                key={service.name}
                title={service.name}
                icon={service.icon}
                href={service.href}
                index={index}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-text-primary mb-4">Datos de Contacto</h2>
            <p className="text-text-secondary">Estamos aquí para ayudarte a tu mascota</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <a
              href="https://wa.me/5492996727809"
              target="_blank"
              rel="noopener noreferrer"
              className="text-center p-6 glass-card bg-primary/5 hover:float transition-all duration-300 cursor-pointer rounded-lg"
            >
              <i className="ph ph-phone text-3xl text-primary mb-3"></i>
              <p className="text-lg font-medium text-text-primary">+54 299 672-7809</p>
            </a>
            <a
              href="https://instagram.com/Elhorconcriollo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-center p-6 glass-card bg-primary/5 hover:float transition-all duration-300 cursor-pointer rounded-lg"
            >
              <i className="ph ph-instagram-logo text-3xl text-primary mb-3"></i>
              <p className="text-lg font-medium text-text-primary">@Elhorconcriollo</p>
            </a>
            <a
              href="mailto:elhorconcriollo@gmail.com"
              className="text-center p-6 glass-card bg-primary/5 hover:float transition-all duration-300 cursor-pointer rounded-lg"
            >
              <i className="ph ph-envelope text-3xl text-primary mb-3"></i>
              <p className="text-lg font-medium text-text-primary">elhorconcriollo@gmail.com</p>
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home